import React from "react";
import sleep from "../../utils/sleep";
import {
  CheckCircleOutline,
  // NotificationsNoneOutlined,
  Cancel,
  Warning,
} from "@mui/icons-material";
import { PopupContent, PopupGeneral, TitlePopup } from "./styles";
import { hidePopup } from "../../store/popup";
import { useDispatch } from "react-redux";
import { POPUP_TIME } from "../../global/variables/popupTime";

export default function PopupMessage({ message, type }) {
  const dispatch = useDispatch();

  React.useEffect(() => {
    const hiddenPopup = async () => {
      await sleep(POPUP_TIME);
      dispatch(hidePopup());
    };
    hiddenPopup();
  }, [dispatch]);

  const typeIcon = {
    default: <CheckCircleOutline style={{ width: "25px", height: "25px" }} />,
    success: <CheckCircleOutline style={{ width: "25px", height: "25px" }} />,
    welcome: <CheckCircleOutline style={{ width: "25px", height: "25px" }} />,
    danger: <Cancel style={{ width: "25px", height: "25px" }} />,
    warning: <Warning style={{ width: "25px", height: "25px" }} />,
  };

  return (
    <PopupGeneral>
      <PopupContent type={type}>
        {typeIcon[type] || typeIcon["default"]}
        <TitlePopup type={type}>{message}</TitlePopup>
      </PopupContent>
    </PopupGeneral>
  );
}
